import { render } from "./Event.vue?vue&type=template&id=6c3dec36&scoped=true&ts=true"
import script from "./Event.vue?vue&type=script&lang=ts"
export * from "./Event.vue?vue&type=script&lang=ts"

import "./Event.vue?vue&type=style&index=0&id=6c3dec36&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c3dec36"]])

export default __exports__